"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const model_interactions_1 = require("@completeanatomy/model-interactions");
const tools_1 = require("@completeanatomy/tools");
const Footer_1 = __importDefault(require("../../molecules/Footer"));
function MainPageLayoutTemplate({ header = null, left = null, 
// showHistory,
disabledButtons = [], children, }) {
    var _a;
    const bodyRegionsButtonIndex = (_a = disabledButtons.indexOf('BodyRegionsButton')) !== null && _a !== void 0 ? _a : -1;
    const isBodyRegionsButtonDisabled = bodyRegionsButtonIndex > -1;
    // const renderMainMenuContainer = () => {
    //   const filteredDisabledButtons = (isBodyRegionsButtonDisabled
    //     ? splice(bodyRegionsButtonIndex, 1)(disabledButtons)
    //     : disabledButtons) as MenuButtonType[];
    //
    //   return <MainMenuContainer disabledButtons={filteredDisabledButtons} />;
    // };
    return ((0, jsx_runtime_1.jsxs)(model_interactions_1.ModelInteractionsLayer, { children: [header, left, (0, jsx_runtime_1.jsx)(Footer_1.default, { isBodyRegionsButtonDisabled: isBodyRegionsButtonDisabled }), children, (0, jsx_runtime_1.jsx)(tools_1.Tools, { selectedToolType: bridge_schema_1.ToolType.None })] }));
}
exports.default = MainPageLayoutTemplate;
